/**
 * Stepa Theme — JavaScript
 * Handles: mobile menu, cart drawer, variants, accordions, quantity selectors
 */
(function() {
  'use strict';

  const SELECTORS = {
    mobileMenu: '[data-mobile-menu]',
    menuToggle: '[data-menu-toggle]',
    menuClose: '[data-menu-close]',
    overlay: '[data-overlay]',
    cartDrawer: '[data-cart-drawer]',
    cartToggle: '[data-cart-toggle]',
    cartCount: '[data-cart-count]',
    quantityInput: '[data-quantity-input]',
    accordionToggle: '[data-accordion-toggle]',
    variantOption: '[data-option]',
    variantId: '[data-variant-id]',
    mainImage: '[data-main-image]',
    thumbnail: '[data-thumbnail]',
    productForm: '[data-product-form]',
    cartNotification: '[data-cart-notification]',
    filterToggle: '[data-filter-toggle]',
    filterPanel: '[data-filter-panel]',
    submenuToggle: '[data-submenu-toggle]',
    addToCart: '[data-add-to-cart]'
  };

  /* ========================================
     Mobile Menu
     ======================================== */
  function initMobileMenu() {
    const menu = document.querySelector(SELECTORS.mobileMenu);
    const toggle = document.querySelector(SELECTORS.menuToggle);
    const close = document.querySelector(SELECTORS.menuClose);
    const overlay = document.querySelector(SELECTORS.overlay);
    if (!menu || !toggle) return;

    toggle.addEventListener('click', function() { openMenu(); });
    close.addEventListener('click', function() { closeMenu(); });
    if (overlay) overlay.addEventListener('click', function() { closeMenu(); });

    function openMenu() {
      menu.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  /* Mobile submenu toggles */
  function initSubmenus() {
    document.querySelectorAll('[data-submenu-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.classList.toggle('is-open');
        var sub = this.nextElementSibling;
        if (sub) sub.classList.toggle('is-open');
      });
    });
  }

  /* ========================================
     Cart Drawer
     ======================================== */
  function initCartDrawer() {
    var drawer = document.querySelector(SELECTORS.cartDrawer);
    if (!drawer) return;

    var toggles = document.querySelectorAll(SELECTORS.cartToggle);
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        drawer.classList.toggle('is-open');
        document.body.style.overflow = drawer.classList.contains('is-open') ? 'hidden' : '';
      });
    });

    var overlay = drawer.querySelector('.cart-drawer__overlay');
    if (overlay) {
      overlay.addEventListener('click', function() {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  }

  /* ========================================
     Quantity Selectors
     ======================================== */
  function initQuantity() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.quantity-btn');
      if (!btn) return;
      var container = btn.closest('.quantity-selector, .cart-item__quantity');
      if (!container) return;
      var input = container.querySelector(SELECTORS.quantityInput);
      if (!input) return;

      var val = parseInt(input.value, 10);
      var action = btn.getAttribute('data-action');

      if (action === 'increase') { input.value = val + 1; }
      else if (action === 'decrease' && val > 1) { input.value = val - 1; }

      input.dispatchEvent(new Event('change', { bubbles: true }));

      // On cart page, auto-submit on change
      var cartForm = input.closest('[data-cart-form]');
      if (cartForm && btn.getAttribute('data-action') !== 'decrease' && btn.getAttribute('data-action') !== 'increase') {
        // submit handled by change event
      }
    });

    // Auto-submit cart form on quantity change
    document.querySelectorAll('[data-cart-form] ' + SELECTORS.quantityInput).forEach(function(input) {
      input.addEventListener('change', function() {
        this.closest('[data-cart-form]').submit();
      });
    });
  }

  /* ========================================
     Product Variant Selection
     ======================================== */
  function initVariants() {
    var form = document.querySelector(SELECTORS.productForm);
    if (!form) return;

    var options = document.querySelectorAll(SELECTORS.variantOption);
    var variantIdInput = document.querySelector(SELECTORS.variantId);
    var addToCartBtn = document.querySelector(SELECTORS.addToCart);
    var priceDisplay = document.querySelector('[data-price]');
    var cartPriceDisplay = document.querySelector('[data-cart-price]');

    if (!options.length) return;

    options.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optionName = this.getAttribute('data-option');
        var optionValue = this.getAttribute('data-value');

        var siblings = document.querySelectorAll('[data-option="' + optionName + '"]');
        siblings.forEach(function(s) { s.classList.remove('is-selected'); });
        this.classList.add('is-selected');

        findAndUpdateVariant();
      });
    });

    function findAndUpdateVariant() {
      var selectedOptions = {};
      document.querySelectorAll('.variant-option.is-selected').forEach(function(btn) {
        selectedOptions[btn.getAttribute('data-option')] = btn.getAttribute('data-display');
      });

      if (typeof window.productVariants !== 'undefined') {
        var variant = window.productVariants.find(function(v) {
          var match = true;
          var optionNames = Object.keys(selectedOptions);
          for (var i = 0; i < optionNames.length; i++) {
            var expected = selectedOptions[optionNames[i]];
            var found = false;
            for (var j = 1; j <= 3; j++) {
              if (v['option' + j] === expected) { found = true; break; }
            }
            if (!found) { match = false; break; }
          }
          return match;
        });

        if (variant) {
          if (variantIdInput) variantIdInput.value = variant.id;
          var fmt = (typeof Shopify !== 'undefined' && Shopify.formatMoney) ? Shopify.formatMoney : function(cents) { return '$' + (cents / 100).toFixed(2); };
          var priceText = fmt(variant.price, window.moneyFormat || '${{amount}}');
          if (priceDisplay) priceDisplay.textContent = priceText;
          if (cartPriceDisplay) cartPriceDisplay.textContent = priceText;

          if (addToCartBtn) {
            if (variant.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = 'Add to Cart';
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = 'Sold Out';
            }
          }
        }
      }
    }
  }

  /* ========================================
     Product Gallery
     ======================================== */
  function initGallery() {
    var mainImg = document.querySelector(SELECTORS.mainImage);
    var thumbs = document.querySelectorAll(SELECTORS.thumbnail);
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var newSrc = this.querySelector('img').src;
        if (newSrc) {
          mainImg.setAttribute('src', newSrc);
          mainImg.setAttribute('srcset', newSrc);
        }
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });
  }

  /* ========================================
     Accordion
     ======================================== */
  function initAccordion() {
    document.querySelectorAll(SELECTORS.accordionToggle).forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        this.classList.toggle('is-open');
        var body = this.nextElementSibling;
        if (body) { body.classList.toggle('is-open'); }
      });
    });
  }

  /* ========================================
     Collection Filters (Basic)
     ======================================== */
  function initFilters() {
    var toggle = document.querySelector(SELECTORS.filterToggle);
    var panel = document.querySelector(SELECTORS.filterPanel);
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function() { panel.classList.toggle('is-open'); });
    document.addEventListener('click', function(e) {
      if (!toggle.contains(e.target) && !panel.contains(e.target)) { panel.classList.remove('is-open'); }
    });
  }

  /* ========================================
     Cart Notification Toast
     ======================================== */
  function initNotification() {
    var notif = document.querySelector(SELECTORS.cartNotification);
    if (!notif) return;
    var closeBtn = notif.querySelector('[data-close-notification]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() { notif.classList.remove('is-visible'); });
    }
  }

  /* ========================================
     Carousel scroll buttons
     ======================================== */
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track || !prev || !next) return;

      prev.addEventListener('click', function() {
        track.scrollBy({ left: -320, behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        track.scrollBy({ left: 320, behavior: 'smooth' });
      });
    });
  }

  /* ========================================
     Slideshow
     ======================================== */
  function initSlideshow() {
    document.querySelectorAll('[data-slideshow]').forEach(function(slideshow) {
      var slides = Array.from(slideshow.querySelectorAll('[data-slideshow-slide]'));
      var dots = Array.from(slideshow.querySelectorAll('[data-slideshow-dot]'));
      var prev = slideshow.querySelector('[data-slideshow-prev]');
      var next = slideshow.querySelector('[data-slideshow-next]');
      if (!slides.length) return;

      var current = 0;
      var interval = null;
      var speed = 5000;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots.length) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots.length) dots[current].classList.add('is-active');
      }

      function startAuto() {
        stopAuto();
        interval = setInterval(function() { goTo(current + 1); }, speed);
      }

      function stopAuto() {
        if (interval) { clearInterval(interval); interval = null; }
      }

      if (prev) {
        prev.addEventListener('click', function() { goTo(current - 1); startAuto(); });
      }
      if (next) {
        next.addEventListener('click', function() { goTo(current + 1); startAuto(); });
      }
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.getAttribute('data-index')));
          startAuto();
        });
      });

      slideshow.addEventListener('mouseenter', stopAuto);
      slideshow.addEventListener('mouseleave', startAuto);
      slideshow.addEventListener('touchstart', stopAuto);
      slideshow.addEventListener('touchend', function() { startAuto(); });

      startAuto();
    });
  }

  /* ========================================
     Fullscreen Media Slideshow
     ======================================== */
  function initFsSlider() {
    document.querySelectorAll('[data-fs-slider]').forEach(function(slider) {
      var slides = Array.from(slider.querySelectorAll('[data-fs-slide]'));
      var dots = Array.from(slider.querySelectorAll('[data-fs-dot]'));
      var prev = slider.querySelector('[data-fs-prev]');
      var next = slider.querySelector('[data-fs-next]');
      if (!slides.length) return;

      var current = 0;
      var interval = null;

      function goTo(index) {
        stopVideo(slides[current]);
        slides[current].classList.remove('is-active');
        if (dots.length) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots.length) dots[current].classList.add('is-active');
      }

      function stopVideo(slide) {
        var cover = slide.querySelector('[data-fs-video-cover]');
        var iframe = slide.querySelector('[data-fs-iframe]');
        if (cover) cover.classList.remove('is-hidden');
        if (iframe) {
          var src = iframe.src;
          iframe.src = '';
          iframe.src = src;
        }
      }

      if (prev) prev.addEventListener('click', function() { goTo(current - 1); });
      if (next) next.addEventListener('click', function() { goTo(current + 1); });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.getAttribute('data-index')));
        });
      });

      // Video play button
      slides.forEach(function(slide) {
        var cover = slide.querySelector('[data-fs-video-cover]');
        var play = slide.querySelector('[data-fs-video-play]');
        if (!cover || !play) return;
        play.addEventListener('click', function() {
          cover.classList.add('is-hidden');
        });
      });

      startAuto();
      function startAuto() {
        stopAuto();
        interval = setInterval(function() { goTo(current + 1); }, 6000);
      }
      function stopAuto() {
        if (interval) { clearInterval(interval); interval = null; }
      }
      slider.addEventListener('mouseenter', stopAuto);
      slider.addEventListener('mouseleave', startAuto);
    });
  }

  /* ========================================
      Mega Menu Image Swap
      ======================================== */
  function initMegaMenuImages() {
    document.querySelectorAll('[data-mega-image-swap]').forEach(function(container) {
      var images = Array.from(container.querySelectorAll('[data-mega-img]'));
      if (!images.length) return;

      var megaPanel = container.closest('[data-mega-panel]');
      if (!megaPanel) return;

      function showImage(colNum) {
        images.forEach(function(img) {
          img.style.display = img.getAttribute('data-mega-img') === colNum ? 'block' : 'none';
        });
      }

      // Show first image by default
      showImage('1');

      // Hover on any link inside a column triggers the corresponding image
      var cols = megaPanel.querySelectorAll('[data-mega-col]');
      cols.forEach(function(col) {
        col.addEventListener('mouseenter', function() {
          var colNum = this.getAttribute('data-mega-col');
          if (colNum) showImage(colNum);
        });
      });

      // Reset to column 1 image when leaving the mega panel
      var megaTrigger = container.closest('.site-nav__item--mega');
      if (megaTrigger) {
        megaTrigger.addEventListener('mouseleave', function() {
          showImage('1');
        });
      }
    });
  }

  /* ========================================
      Product gallery delayed sticky
      ======================================== */
  function initGalleryScroll() {
    var gallery = document.querySelector('.main-product__gallery');
    var info = document.querySelector('.main-product__info');
    if (!gallery || !info) return;

    var offset = 96; // header 72 + gap 24
    gallery.style.position = 'sticky';
    gallery.style.top = '-' + (info.offsetHeight - gallery.offsetHeight) + 'px';
    gallery.style.alignSelf = 'start';
  }
  function initGalleryArrows() {
    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    var mainImg = document.querySelector('[data-main-image]');
    if (!prev || !next || !mainImg) return;
    var allThumbs = Array.from(document.querySelectorAll('[data-thumbnail]'));

    function goTo(step) {
      var visibleThumbs = allThumbs.filter(function(t) { return t.style.display !== 'none'; });
      if (!visibleThumbs.length) return;
      var currentActive = visibleThumbs.findIndex(function(t) { return t.classList.contains('is-active'); });
      if (currentActive === -1) currentActive = 0;
      var newIndex = currentActive + step;
      if (newIndex < 0) newIndex = visibleThumbs.length - 1;
      if (newIndex >= visibleThumbs.length) newIndex = 0;
      visibleThumbs.forEach(function(t) { t.classList.remove('is-active'); });
      visibleThumbs[newIndex].classList.add('is-active');
      var src = visibleThumbs[newIndex].getAttribute('data-src');
      if (src) { mainImg.setAttribute('src', src); mainImg.setAttribute('srcset', visibleThumbs[newIndex].getAttribute('data-srcset') || src); }
    }

    prev.addEventListener('click', function() { goTo(-1); });
    next.addEventListener('click', function() { goTo(1); });
  }
  function initThumbnailMore() {
    var moreBtn = document.querySelector('[data-thumbnail-more]');
    if (!moreBtn) return;
    moreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var hiddenThumbs = document.querySelectorAll('.product-gallery__thumb--hidden');
      hiddenThumbs.forEach(function(t) { t.style.display = ''; });
      moreBtn.style.display = 'none';
    });
  }

  /* ========================================
      Initialize everything
     ======================================== */
  function init() {
    initMobileMenu();
    initSubmenus();
    initCartDrawer();
    initQuantity();
    initVariants();
    initGallery();
    initAccordion();
    initFilters();
    initNotification();
    initCarousel();
    initSlideshow();
    initFsSlider();
    initMegaMenuImages();
    initThumbnailMore();
    initGalleryArrows();
    initProductGalleryScroll();
    initProductVariants();
    initSlideshowArrows();
  }
  function initSlideshowArrows() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.fs-slider__arrow--prev');
      if (btn && window.slidePrev) { e.preventDefault(); window.slidePrev(btn); return; }
      btn = e.target.closest('.fs-slider__arrow--next');
      if (btn && window.slideNext) { e.preventDefault(); window.slideNext(btn); return; }
      btn = e.target.closest('[data-fs-dot]');
      if (btn && window.slideGoTo) { e.preventDefault(); window.slideGoTo(btn, parseInt(btn.getAttribute('data-index')) || 0); return; }
    });
  }
  function initProductGalleryScroll() {
    var gallery = document.querySelector('.main-product__gallery');
    if (!gallery) return;
    var grid = gallery.closest('.main-product__grid');
    if (!grid) return;
    var galleryRect = gallery.getBoundingClientRect();
    var galleryTop = galleryRect.top + window.pageYOffset;
    var stickyOffset = 96; // header + gap
    var delay = 120;

    function isDesktop() { return window.innerWidth > 768; }

    window.addEventListener('scroll', function() {
      if (!isDesktop()) return;
      var scrollY = window.pageYOffset;
      if (scrollY > galleryTop - stickyOffset - delay) {
        gallery.style.position = 'sticky';
        gallery.style.top = stickyOffset + 'px';
        gallery.style.alignSelf = 'start';
      } else {
        gallery.style.position = '';
        gallery.style.top = '';
      }
    });

    window.addEventListener('resize', function() {
      if (!isDesktop()) {
        gallery.style.position = '';
        gallery.style.top = '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Global slideshow helpers */
  window.slidePrev = function(btn) {
    var s = btn.closest('[data-fs-slider]'); if (!s) return;
    var slides = s.querySelectorAll('[data-fs-slide]');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) {
        slides[i].classList.remove('is-active');
        var idx = (i - 1 + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        var dots = s.querySelectorAll('[data-fs-dot]');
        dots.forEach(function(d) { d.classList.remove('is-active'); });
        if (dots[idx]) dots[idx].classList.add('is-active');
        return;
      }
    }
  };
  window.slideNext = function(btn) {
    var s = btn.closest('[data-fs-slider]'); if (!s) return;
    var slides = s.querySelectorAll('[data-fs-slide]');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) {
        slides[i].classList.remove('is-active');
        var idx = (i + 1) % slides.length;
        slides[idx].classList.add('is-active');
        var dots = s.querySelectorAll('[data-fs-dot]');
        dots.forEach(function(d) { d.classList.remove('is-active'); });
        if (dots[idx]) dots[idx].classList.add('is-active');
        return;
      }
    }
  };
  window.slideGoTo = function(btn, index) {
    var s = btn.closest('[data-fs-slider]'); if (!s) return;
    var slides = s.querySelectorAll('[data-fs-slide]');
    for (var i = 0; i < slides.length; i++) { slides[i].classList.toggle('is-active', i == index); }
    var dots = s.querySelectorAll('[data-fs-dot]');
    dots.forEach(function(d) { d.classList.remove('is-active'); });
    if (dots[index]) dots[index].classList.add('is-active');
  };

  /* ========================================
      Product variant handling
      ======================================== */
  function initProductVariants() {
    var dataEl = document.getElementById('product-variants-data');
    if (!dataEl) return;
    try {
      window.productVariants = JSON.parse(dataEl.textContent);
    } catch(e) {
      return;
    }

    window.onVariantClick = function(btn) {
      var n = btn.getAttribute('data-option');
      var v = btn.getAttribute('data-value');
      var d = btn.getAttribute('data-display');
      var s = document.querySelectorAll('[data-option="' + n + '"]');
      var l = document.querySelector('[data-option-label="' + n + '"]');
      s.forEach(function(x) { x.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      if (l) l.textContent = d;
      if (n === 'color') { window.updateFirstThumb(v); }
      window.updateVariantBySelections();
    };

    window.updateVariantBySelections = function() {
      var pv = window.productVariants;
      if (!pv) return;
      var selected = {};
      document.querySelectorAll('.variant-option.is-selected').forEach(function(b) {
        selected[b.getAttribute('data-option')] = b.getAttribute('data-display');
      });
      var keys = Object.keys(selected);
      var matched = null;
      for (var i = 0; i < pv.length; i++) {
        var match = true;
        for (var k = 0; k < keys.length; k++) {
          var found = false;
          for (var j = 1; j <= 3; j++) {
            if (pv[i]['option' + j] == selected[keys[k]]) { found = true; break; }
          }
          if (!found) { match = false; break; }
        }
        if (match) { matched = pv[i]; break; }
      }
      if (matched) {
        var input = document.querySelector('[data-variant-id]');
        var priceEl = document.querySelector('[data-price]');
        var atc = document.querySelector('[data-add-to-cart]');
        if (input) input.value = matched.id;
        if (priceEl) priceEl.textContent = '$' + (matched.price / 100).toFixed(2);
        if (atc) {
          if (matched.available) { atc.disabled = false; atc.textContent = 'Add to Cart'; }
          else { atc.disabled = true; atc.textContent = 'Sold Out'; }
        }
      }
    };

    window.updateFirstThumb = function(colorHandle) {
      var pv = window.productVariants;
      if (!pv) return;
      var firstVariant = null;
      for (var i = 0; i < pv.length; i++) {
        for (var j = 1; j <= 3; j++) {
          var opt = pv[i]['option' + j];
          if (opt && opt.toLowerCase().replace(/\s+/g, '-') == colorHandle) {
            firstVariant = pv[i]; break;
          }
        }
        if (firstVariant) break;
      }
      if (firstVariant && firstVariant.featured_image) {
        var imgSrc = firstVariant.featured_image.src;
        var thumbs = document.querySelectorAll('[data-thumbnail]');
        var first = thumbs[0];
        if (first) {
          first.querySelector('img').src = imgSrc;
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          first.classList.add('is-active');
          var mainImg = document.querySelector('[data-main-image]');
          if (mainImg) { mainImg.src = imgSrc; mainImg.srcset = ''; }
        }
      }
    };
  }

})();
